export const columns = [
    {
        title:'发布日期',
        dataIndex:"createTime",
        key:"createTime"
    },
    {
        title:'主题',
        dataIndex:"policyTheme",
        key:"policyTheme"
    },
    {
        title:'发布类型',
        dataIndex:"type",
        key:"type",
        slots:'type',
    },
    // {
    //     title:'政策内容',
    //     dataIndex:"policyContent",
    //     key:"policyContent"
    // },
    {
        title:'附件',
        dataIndex:"accessory",
        key:"accessory",
        slots:"accessory"
    },
    {
        title:'操作人',
        dataIndex:"revisorName",
        key:"revisorName"
    },
    {
        title:'操作时间',
        dataIndex:"updateTime",
        key:"updateTime"
    },
    {
        title: "操作",
        slots:'actions',
        width:180,
        fixed:'right'
    },
]